(function($){

    $(document).ready(function() {

        //START video in background
        $('[data-youtube]').youtube_background();
        //STOP video in background

    });

})
(jQuery);
